var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid",class:{
    click: _vm.to,
  },attrs:{"src":_vm.src,"alt":"Image"},on:{"click":function($event){return _vm.goTo(_vm.to)}}})}
var staticRenderFns = []

export { render, staticRenderFns }